import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonsWrapper, Sum, SumContent, SumText, TipSelectionContent, TipSelectionWrap } from '../index.styled'
import Button from '../../../buttons/Button'
import CustomModal from '../../../modal/CustomModal'
import Currency from '../../../currency'
import { roundPrice } from '../../../../../helper'
import { getPercentsTips } from '../helper'
import TipsButton from './tipsButton'
import { TipsButtonWrapper } from './index.styled'
import { colorTheme } from '../../../../../style/theme/colorTheme'
import { useDispatch } from 'react-redux'
import { setTap2PayTips } from '../../../../../redux/action/tap2Pay'
import { setRestaurantPaymentTypeModal } from '../../../../../redux/action/restaurant'

const EVENT_Z_INDEX = 95
const buttons = [{ text: '10%', value: 10 }, { text: '15%', value: 15 }, { text: '20%', value: 20 }]

const ModalTipSelection = React.memo(({ totalPrice, isOpen, setShowProcessPaymentTap2PayModal, setShowTipSelectionModal, setShowChangePaymentAmountModal, setShowChangeTipsModal }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const roundedTotalPrice = roundPrice(totalPrice)
	const [selectedTipsIndex, setSelectedTipsIndex] = useState()

	const handleSelectTips = useCallback((index, value) => {
		const tips = getPercentsTips(totalPrice, value)
		setSelectedTipsIndex(index)
		dispatch(setTap2PayTips(tips))
		setShowTipSelectionModal(false)
		setShowProcessPaymentTap2PayModal(true)
	}, [totalPrice, dispatch, setShowTipSelectionModal, setShowProcessPaymentTap2PayModal])

	const handleClose = useCallback(() => {
		setShowTipSelectionModal(false)
		dispatch(setRestaurantPaymentTypeModal(true))
	}, [dispatch, setShowTipSelectionModal])

	const handleBack = useCallback(() => {
		setShowTipSelectionModal(false)
		setShowChangePaymentAmountModal(true)
	}, [setShowChangePaymentAmountModal, setShowTipSelectionModal])

	const handleChangeOtherTips = useCallback(() => {
		setShowTipSelectionModal(false)
		setShowChangeTipsModal(true)
	}, [setShowChangeTipsModal, setShowTipSelectionModal])

	const handlePayWithoutTips = useCallback(() => {
		setShowTipSelectionModal(false)
		setShowProcessPaymentTap2PayModal(true)
	}, [setShowProcessPaymentTap2PayModal, setShowTipSelectionModal])

	return (
		<CustomModal isOpen={isOpen}
								 close={handleClose}
								 id="modal-tip-selection"
								 size="x-small"
								 title={t('Tap2PayModals.tip')}
								 disableBackButton={true}
								 zIndex={EVENT_Z_INDEX}
								 button={<ButtonsWrapper>
									 <Button name="back" icon="back" text={t('Cart.Buttons.back')} zIndex={EVENT_Z_INDEX} color="gray" onClick={handleBack} />
								 </ButtonsWrapper>}>
			<TipSelectionWrap>
				<SumContent>
					<SumText>{t('Tap2PayModals.total')}:</SumText>
					<Sum><Currency>{roundedTotalPrice}</Currency></Sum>
					<SumText>{t('Tap2PayModals.addTips')}</SumText>
				</SumContent>
				<TipSelectionContent>
					<TipsButtonWrapper>
						{buttons.map((button, index) => (
							<TipsButton key={index}
													index={index}
													active={selectedTipsIndex === index}
													button={button}
													title={button.text}
													totalSum={totalPrice}
													onClick={handleSelectTips} />
						))}
					</TipsButtonWrapper>
					<Button name="otherTips"
									outline
									textColor={colorTheme.Tap2PayModals.btnOutline.text}
									text={t('Tap2PayModals.tipSelection.otherTips')}
									onClick={handleChangeOtherTips} />
					<Button name="withoutTips"
									outline
									textColor={colorTheme.Tap2PayModals.btnOutline.text}
									text={t('Tap2PayModals.tipSelection.withoutTips')}
									onClick={handlePayWithoutTips} />
				</TipSelectionContent>
			</TipSelectionWrap>
		</CustomModal>)
})
ModalTipSelection.displayName = 'ModalTipSelection'
export default ModalTipSelection
